import { SpinnerModal } from 'Src/app/shared/modals/status-spinner/status-spinner.service';
import { IStateService } from 'angular-ui-router';
import { ListNavigationService } from './../../school/lists/services/list-navigation/list-navigation.service';
import { TSortDirections, SortAndFilterService } from 'Src/ng2/shared/services/list-services/sort-and-filter.service';
import { IListConfig } from 'Src/ng2/shared/models/list-models';
import { of } from 'rxjs/observable/of';
import { FixedToInfiniteViewComponent } from 'Src/ng2/shared/components/list/fixed-to-infinite-view-container/fixed-to-infinite-view.component';
import { FormControl } from '@angular/forms';
import { ListHeaderService } from './../../school/lists/services/list-headers/list-headers.service';
import { tap, map } from 'rxjs/operators';
import { NetworkStudentLevelDataService } from './network-student-level-data/network-student-level-data.service';
import {
  Component,
  Input,
  ElementRef,
  ComponentFactoryResolver,
  ViewContainerRef,
  ViewChild,
  ComponentRef,
  Inject,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'network-student-level',
  template: require('./network-student-level.component.html'),
  styles: [require('./network-student-level.component.scss')],
})
export class NetworkStudentLevelComponent extends FixedToInfiniteViewComponent {
  @Input() midlevelData: any;

  // Refs
  @ViewChild('entry', { read: ViewContainerRef, static: true }) entry: ViewContainerRef;
  @ViewChild('listContent', { static: true }) listContent: ElementRef;

  onUiRowDataUpdate = () => null;
  onRowClick = () => null;
  onBatchAction = () => null;
  batchActionsMode$ = of(false);
  updateSort: Function;

  public pageHeaderMeta = {
    title: 'Student List',
    subTitle: null,
    icon: {
      name: 'arrow-left',
      tooltip: 'Back to Breakdown',
    },
  };

  sortKey$ = new BehaviorSubject('STUB');
  sortDirection$ = new BehaviorSubject('asc' as TSortDirections);

  public listConfig: IListConfig = {
    listType: 'NETWORK',
    noDataMessage: 'No students to display',
    sortableColumns: true,
  };

  onFixed: Function;
  onInfinite: Function;

  columns;
  columnIndexMap;
  dynamicColumns;
  dynamicColumnIndexMap = null;
  groupingData$ = new BehaviorSubject(null);
  filterFormControl = new FormControl();
  noDataMessage = null;
  schoolId = null;

  constructor(
    public dataService: NetworkStudentLevelDataService,
    public listHeaderService: ListHeaderService,
    public navigationService: ListNavigationService,
    public resolver: ComponentFactoryResolver,
    @Inject('$state') public $state: IStateService,
    @Inject('SpinnerModal') public spinnerService: SpinnerModal,
  ) {
    super(resolver);
  }

  ngOnInit() {
    this.spinnerService.activateSpinner('Loading...');
    // Set subclass props
    this.onFixed = () => {
      this.listContent.nativeElement.classList.remove('infinite');
      this.pageHeaderMeta = { ...this.pageHeaderMeta, ...{ icon: this.getFixedHeaderIcon() } };
    };

    this.onInfinite = (instance: ComponentRef<any>) => {
      this.listContent.nativeElement.classList.add('infinite');
      this.pageHeaderMeta = { ...this.pageHeaderMeta, ...{ icon: this.getInfiniteHeaderIcon(instance) } };
    };

    this.updateSort = (sortKey: string) =>
      SortAndFilterService.updateSortCol(sortKey, this.sortKey$, this.sortDirection$);

    // Initialize list
    this.dataService
      .getNetworkStudentGroupData$(this.midlevelData.focusKey, this.midlevelData.filters)
      .pipe(
        tap(({ columnData }) => {
          this.columns = columnData;
          this.columnIndexMap = columnData.reduce((mapping, col, i: number) => {
            mapping[col.graphQlKey] = i;
            return mapping;
          }, {});
        }),
        map(({ groupData }) => groupData),
        tap(groupData => {
          this.groupingData$.next(groupData);
          this.createListContainer();
          this.spinnerService.deactivateSpinner();
        }),
      )
      .subscribe();
  }

  getInfiniteHeaderIcon(instance: any) {
    const handler = () => (instance.aniState = 'collapsed');
    return {
      name: 'close',
      tooltip: 'Close',
      handler,
    };
  }

  getFixedHeaderIcon() {
    return {
      name: 'arrow-left',
      tooltip: 'Back to Breakdown',
      handler: () => {
        this.$state.go('main.network.midlevel', { madlibModel: this.midlevelData.madlibModel });
      },
    };
  }
}
